<template>
  <div>
    <section class="title-box">
      <div class="container">
        <h1>{{ $t("套票種類") }}</h1>
      </div>
    </section>
    <section class="main-box">
      <div class="container">
        <div class="btn-box">
          <!-- 0517 換img圖 -->
          <div class="btn ticket-btn" id="btn">
            <router-link :to="{ name: 'MProductList' }" tag="button"
              ><img src="img/icon-month.png" alt="" />{{
                $t("月週票")
              }}</router-link
            >
            <router-link :to="{ name: 'ProductList' }" tag="button"
              ><img src="img/icon-time.png" alt="" />{{
                $t("時數票")
              }}</router-link
            >
            <button class="btnadd">
              <img src="img/icon-points.png" alt="" />{{ $t("POINT") }}
            </button>
          </div>
        </div>
        <div class="row">
          <div
            class="box col-12 col-md-6 col-lg-3"
            v-for="ProductPoint in ProductPointData.ProductPoints"
            :key="ProductPoint.PPId"
          >
            <img :src="SiteUrl + ProductPoint.Image" alt="" />
            <!-- 0613 擴大a連結  -->
            <router-link
              :to="{
                name: 'ProductPoint',
                params: { PPId: ProductPoint.PPId },
              }"
            >
              <div class="text-box">
                <h2>{{ ProductPoint.Name }}</h2>
                <div class="price">
                  <p v-if="ProductPoint.Price > 0">
                    NTD{{ ProductPoint.Price }}
                  </p>
                  <p v-if="ProductPoint.Price == 0"></p>
                  <p>POINTS</p>
                  <p>{{ ProductPoint.Bonus }}</p>
                </div>
                <!-- 0613 修改 a連結改成div -->
                <div
                  :to="{
                    name: 'ProductPoint',
                    params: { PPId: ProductPoint.PPId },
                  }"
                  class="shopping-cart"
                >
                  <img src="img/icon-shopping-cart.png" alt="" />
                </div>
              </div>
            </router-link>
          </div>
        </div>
      </div>
    </section>
    <!-- 底部加高 底部固定選單fixed的高度 -->
    <div class="nav-menu-bg"></div>
  </div>
</template>

<script>
import Vue from "vue";
import axios from "axios";
import VueAxios from "vue-axios";
import AES from "@/utils/aes.js";
import CryptoJS from "crypto-js";
import VueI18n from "vue-i18n";
import Storage from "@/utils/storage.js";

Vue.use(VueAxios, axios);
Vue.use(VueI18n);

// this.$t("立即購買")
const messages = {
  zh_tw: {
    套票種類: "套票種類",
    月週票: "月週票",
    時數票: "時數票",
    點數: "點數",
  },
  en: {
    套票種類: "Pass type",
    月週票: "M/W pass",
    時數票: "Hour pass",
    點數: "Points",
  },
};

const i18n = new VueI18n({
  locale: "zh_tw",
  messages,
});

export default {
  name: "ProductPointList",
  i18n,
  data() {
    return {
      SiteUrl: "",
      ProductPointData: {},
      ProductPointsCount: 0,
    };
  },
  created: function () {
    Vue.axios
      .get(
        this.GLOBAL.apiSrc +
          this.GLOBAL.subDirectory +
          "/Htmlv2/ProductPointList",
        {
          params: {
            token: Storage.get("ek_login_token"),
            lang: Storage.get("ek_site_lang"),
          },
        }
      )
      .then((response) => {
        this.SiteUrl = response.data.SiteUrl;
        this.ProductPointData = response.data.ProductPointData;
        this.ProductPointsCount = response.data.ProductPointsCount;
      })
      .catch((error) => {
        console.log(error);
      });
  },
  mounted: function () {
    // 回頂端
    $(window).scrollTop(0);
    // 套用Class
    $(".wrapper").addClass("package-list");
    // i18n
    if (Storage.isKey("ek_site_lang")) {
      i18n.locale = Storage.get("ek_site_lang");
    } else {
      i18n.locale = "zh_tw";
    }
  },
  updated: function () {
    if ($(".package-check").hasClass("slick-initialized")) {
      $(".package-check").slick("unslick");
    }

    $(".package-nav-first").slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: true,
      fade: true,
      asNavFor: ".package-for-first",
    });

    $(".package-for-first").slick({
      slidesToShow: 3,
      slidesToScroll: 1,
      arrows: false,
      // fade: true,
      asNavFor: ".package-nav-first",
      dots: false,
      responsive: [
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 1,
            centerMode: false,
          },
        },
      ],
      autoplay: true,
      autoplaySpeed: 5000,
    });
  },
  methods: {},
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
section.main-box {
  min-height: 500px;
}
</style>



// WEBPACK FOOTER //
// src/components/ProductPointList.vue